var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ride-Show-Copy-41",
    transform: "translate(-281.000000, -563.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.745,566.992 L282.321149,566.909629 L282.231502,566.914797 C281.800961,566.976422 281.641851,567.556358 282.025047,567.820938 L284.843,569.767 L283.70722,572.998134 L283.685334,573.079944 C283.606054,573.510901 284.11093,573.845144 284.482425,573.561353 L287.204,571.482 L289.926052,573.561353 L289.997095,573.607449 C290.38246,573.816021 290.856359,573.439143 290.701257,572.998134 L289.565,569.767 L292.38343,567.820938 L292.452919,567.764064 C292.765011,567.461142 292.552856,566.898441 292.087328,566.909629 L288.663,566.992 L287.683342,563.709946 C287.541244,563.233998 286.867232,563.233998 286.725135,563.709946 L285.745,566.992 Z",
    id: "Star"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite);
export default __webpack_public_path__ + "static/media/icon-favorite.9f94dc14cb47dfe4eabb47423ee4c87f.svg";
export { ForwardRef as ReactComponent };